// MapToggle.jsx
import React from "react";
import Switch from "react-switch";

interface MapToggleProps {
  showMap: boolean;
  setShowMap: (prev: (prevState: boolean) => boolean) => void;
}

const MapToggle = ({ showMap, setShowMap }: MapToggleProps) => {
  // Use a unique ID for accessibility
  const toggleId = "map-view-toggle";

  return (
    <div className="switch-container text-center mt-xl-5 mb-xl-5 d-flex justify-content-center align-items-center ">
      {/* Hidden actual input for accessibility */}
      <input
        type="checkbox"
        id={toggleId}
        checked={showMap}
        onChange={() => setShowMap((prev) => !prev)}
        className="sr-only d-none"
        aria-labelledby="map-toggle-label"
      />

      {/* Visual label */}
      <span
        id="map-toggle-label"
        className="mr--10 mb--30"
        style={{ marginBottom: 0 }}
      >
        Map
      </span>
      {/* Visual toggle (not the actual control) */}
      <Switch
        checked={showMap}
        onChange={() => setShowMap((prev) => !prev)}
        checkedIcon={false}
        uncheckedIcon={false}
        aria-hidden="true" // Hide from screen readers as we have a proper input above
      />
    </div>
  );
};

export default React.memo(MapToggle);
